"use client";
import {
  useSelectContext
} from "./LM7KIZUU.js";
import {
  usePopoverDisclosureArrow
} from "./A5NH37Z4.js";
import {
  createElement,
  createHook,
  forwardRef
} from "./VOQWLFSQ.js";
import {
  __objRest,
  __spreadValues
} from "./3YLGPPWQ.js";

// src/select/select-arrow.tsx
var TagName = "span";
var useSelectArrow = createHook(
  function useSelectArrow2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useSelectContext();
    store = store || context;
    props = usePopoverDisclosureArrow(__spreadValues({ store }, props));
    return props;
  }
);
var SelectArrow = forwardRef(function SelectArrow2(props) {
  const htmlProps = useSelectArrow(props);
  return createElement(TagName, htmlProps);
});

export {
  useSelectArrow,
  SelectArrow
};
